<template>

    <v-avatar>
      <img :src="img"  :size="64">
    </v-avatar>

</template>
<script>
/* eslint-disable */
import axios from "axios";
import config from "@/config";
export default {
  props: {
    json_data: ""
  },

  data: () => ({
    img: "",
    guid: ""
  }),
  created: function() {
    this._getImage(this.json_data);
  },

  methods: {
    _getImage(data) {
      this.getEmpDetail(data)
        .then(res => {
         // console.log(res);
          this.img = res.data.image_file;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getEmpDetail(data) {
     // console.log(data);
      const _token = localStorage._token;
      const _company_guid = localStorage._company_guid;
      const http = axios.create({
        baseURL: config.API_URL
      });
      return http.get(`/emp-image/`+data, {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + _token,
          "X-TenantID": _company_guid
        }
      });
    }
  }
};
</script>
